import React from 'react';
import Grid from '@material-ui/core/Grid';
import Skeleton from '@material-ui/lab/Skeleton';
import FPActionButton from 'UI/components/atoms/FPActionButton';
import { COMPANY_RELATIONSHIP_KEY } from 'UI/constants/defaults';
import { SvgAdd, SvgEdit } from 'UI/res';

import RelationshipOverview from './RelationshipOverview';

/**
 * @typedef {Object} AssociatedCompanyOption
 * @property {string} id
 * @property {string} text
 * @property {string} actionText
 * @property {Function} onClick
 * @property {boolean} enabled
 */

/**
 * @typedef {Object} AssociatedCompaniesData
 * @property {Object} parentCompany
 * @property {Array} childCompanies
 * @property {Array} siblingCompanies
 */

const SKELETON_BUTTONS_SIZES = {
  width: 200,
  height: 40
};

/**
 * @param {Object} props
 * @param {('column'|'row')} [props.direction='row']
 * @param {AssociatedCompanyOption[]} [props.options]
 * @param {AssociatedCompaniesData} [props.associatedCompanies]
 * @param {boolean} props.isLoading
 */
const AssociatedCompaniesOptions = ({ associatedCompanies, direction, options, isLoading }) => {
  const isColumn = direction === 'column';

  const transformedOptions = options.map(opt => {
    const buttonText = `${opt.actionText} ${opt.text}`;
    const buttonIcon = opt.actionText === 'Add' ? SvgAdd : SvgEdit;
    const companyData =
      opt.id === COMPANY_RELATIONSHIP_KEY.parentCompany
        ? associatedCompanies.parentCompany
        : associatedCompanies[opt.id];
    const data = [companyData].flat();
    return {
      buttonText,
      buttonIcon,
      data,
      ...opt
    };
  });

  return (
    <Grid
      container
      direction={direction}
      spacing={5}
      justifyContent={isColumn ? 'flex-start' : 'flex-end'}
    >
      {transformedOptions.map(opt => {
        return (
          <Grid item key={opt.id}>
            {isColumn && (
              <RelationshipOverview
                direction="row"
                data={opt.data}
                title={opt.text}
                type={opt.id}
              />
            )}
            {isLoading ? (
              <Skeleton
                variant="rect"
                animation="pulse"
                width={SKELETON_BUTTONS_SIZES.width}
                height={SKELETON_BUTTONS_SIZES.height}
              />
            ) : (
              <FPActionButton
                icon={opt.buttonIcon}
                iconProps={{ size: 'sm' }}
                onClick={opt.onClick}
                text={opt.buttonText}
                disabled={!opt.enabled}
              />
            )}
          </Grid>
        );
      })}
    </Grid>
  );
};

AssociatedCompaniesOptions.defaultProps = {
  direction: 'row',
  options: null,
  associatedCompanies: {
    parentCompany: null,
    siblingCompanies: null,
    childCompanies: null
  }
};

export default AssociatedCompaniesOptions;
